import { gql } from "@apollo/client";
import { formatSql } from "../utils/sqlFormatting";

export const UpdateWorker = gql`
  mutation UpdateWorker($id: String, $worker: Worker) {
    UpdateWorker(id: $id, worker: $worker) {
      data
    }
  }
`;

export const Coders = gql`
    query Coders( 
        $pageNumber: Int
        $pageSize: Int
        $order: String
        $sort: String
    ) 
      {
        Coders(
          pageNumber: $pageNumber
          pageSize: $pageSize
          order: $order
          sort: $sort
        ) 
          {
            data
            total
          }
      }
`;

export const GetWorkers = gql`
    query Workers( 
        $pageNumber: Int
        $pageSize: Int
        $order: String
        $sort: String
    ) 
      {
        Workers(
          pageNumber: $pageNumber
          pageSize: $pageSize
          order: $order
          sort: $sort
        ) 
          {
            data
            total
          }
      }
`;

export const SearchWorkers = gql`
  mutation SearchWorker($request: SearchWorkerRequest!) {
    SearchWorker(request: $request) {
      data
      total
    }
  }
`;

export const QueryWorkers = gql`
  mutation QueryWorker($workerQuery: workerQuery!) {
    QueryWorker(workerQuery: $workerQuery)
  }
`;

export const GetQueryWorkersByWorkerId = (workerIds: string[]) => {
  return formatSql`
    SELECT * FROM worker WHERE worker_id IN (${workerIds.map(id => `'${id}'`).join(',')});
  `;
}